<template lang="html">
  <model-select :options="_options"
                  v-model="item"
                  placeholder="Choose">
   </model-select>
</template>
<script>
import { ModelSelect } from 'vue-search-select'

export default {
  components: {
    ModelSelect
  },
  props: {
    placeholder: {},
    onChange: {
      default: () => {},
      type: Function
    },
    options: {
      type: [Array, Object]
    },
    'api-url': {
    },
    method: {
    },
    value: {
    }
  },
  data () {
    return {
      item: {
        value: '',
        text: ''
      }
    }
  },
  computed: {
    _$1_options() {
      let options = this.options
      if(!Array.isArray(options)) {
        return options
      }
      let obj = {}
      options.forEach(v => {
        obj[v] = v
      })
      return obj
    },
    _options() {
      let arr = []
      let options = this._$1_options
      arr.length = Object.keys(options).length
      let i = 0
      let cap = this.$options.filters.cap
      for(let field in options) {
        let val = '' + options[field]
        arr[i++] = {
          value: field, text: cap(val)
        }
      }
      return arr
    }
  },
  watch: {
    item(val) {
      this.onChange(val.value)
    },
    value(val) {
      if(!val) {
        return this.item = this._options[0]
      }
      this.item.value = val
    }
  },
  created() {
    // if(this.value) {
    //   this.item.value = this.value
    // }
  }
}
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/Select.vue